import { connect } from "react-redux";
import { ThunkDispatch } from "redux-thunk";

import { ApplicationState } from "../../store/ApplicationState";
import Header from "../components/Header";
import { AllLogoutDispatchTypes } from "../../models/DispatchTypes/Logout";
import { LogoutOfApp } from "../../actions/Logout";
import { getSessionStorage } from "../../utils";

const mapStateToProps = ({ logoutState, exchangedTokenState, userModuleState}: ApplicationState) => {
  const sessionUser = getSessionStorage("loggedInUser") || {};
  return {
    logoutResp: logoutState,
    exchangedTokenResp: exchangedTokenState,
    firstName: exchangedTokenState.response?.user?.firstName ?? sessionUser.firstName ?? "",
    lastName: exchangedTokenState.response?.user?.lastName ?? sessionUser.lastName ?? "",
    roleType: exchangedTokenState.response?.user?.roleType ?? sessionUser.roleType ?? "",
    healthPlanName: exchangedTokenState.response?.user?.healthPlanName ?? sessionUser.healthPlanName ?? "",
    userModules: userModuleState.response ?? [],
  };
};

const mapDispatchToProps = (
  dispatch: ThunkDispatch<
    ApplicationState,
    Record<string, never>,
    AllLogoutDispatchTypes
  >
) => {
  return {
    logoutOfApp: () => {
      dispatch(LogoutOfApp());
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);